import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { GlobalStyled } from './GlobalStyled.jsx';
import { UsuarioProvider } from './contexto/SessaoUsuario.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
    <GlobalStyled />
    <UsuarioProvider>
        <App />
    </UsuarioProvider>
</>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
